module.exports = __webpack_public_path__ + "static/media/apparel.40be0aca.jpeg";